import { render, staticRenderFns } from "./reservpleisure.vue?vue&type=template&id=f2ed11e6&scoped=true&"
import script from "./reservpleisure.vue?vue&type=script&lang=js&"
export * from "./reservpleisure.vue?vue&type=script&lang=js&"
import style0 from "./reservpleisure.vue?vue&type=style&index=0&id=f2ed11e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed11e6",
  null
  
)

export default component.exports